import {TaxInfo} from '@wix/auto_sdk_ecom_current-cart-v-2';

export class TaxInfoModel {
  public pricesIncludeTax?: boolean;

  constructor(params: TaxInfoModel) {
    this.pricesIncludeTax = params.pricesIncludeTax;
  }

  public static fromCartV1(pricesIncludeTax?: boolean): TaxInfoModel {
    return new TaxInfoModel({
      pricesIncludeTax,
    });
  }

  public static fromCartV2(taxInfo: TaxInfo): TaxInfoModel {
    return new TaxInfoModel({
      pricesIncludeTax: taxInfo?.pricesIncludeTax,
    });
  }
}
